var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropfiles"},[_c('h2',{staticClass:"font-light text-lg mb-5"},[_vm._v("ENVOYER LE FICHIER :")]),_c('upload-files',{on:{"uploadDone":function($event){return _vm.listUploadedFiles()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }